import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("si_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const biz = localStorage.getItem("si_business");
  if (biz) config.headers["X-Business-Id"] = biz;
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fileUrl = (fileId) =>
  `${API}/files/${fileId}?auth=${encodeURIComponent(localStorage.getItem("si_token") || "")}`;

export { API };
export default api;
